<template>
    <div class="pa-6">
        <Invoice :invoice="invoice" />
        <!-- <a :href="`//pdfcrowd.com/${thisPage}/`" target="_blank"> -->
        <a class="pdfcrowd-remove mt-5" href="//pdfcrowd.com/url_to_pdf/" target="_blank">
            <v-btn color="primary" rounded>
                Save to PDF
            </v-btn>
        </a>
    </div>
</template>

<script>
import LayoutContainer from '@/ui-elements/LayoutContainer'

import NiceData from '../../data/NiceData'
import DataHelpers from '../../helpers/DataHelpers'

import firebase from 'firebase/app'
import 'firebase/database'

import Invoice from './Invoice'

export default {
    name: 'OneInvoice',
    data() {
        return {
            invoice: {charges:[], from:{}, to:{}}
        }
    },

    components: {
        Invoice,
    },    

    props: {
        invoiceKey: String,
        month: String,
    },        

    computed:{
        thisPage() {
            return encodeURI(window.location)
        }
    },

    watch: {

    },

    methods: {
 

    },

    async created () {
        const ref = DataHelpers.getRootRef().child('app/billing').child(this.month).child('invoices').child(this.invoiceKey)
        const invoice = await NiceData.fetchItemSingle(ref)

        const chargeRef = DataHelpers.getRootRef().child(`app/billing/${this.month}/charges`)
            .orderByChild('invoice').equalTo(this.invoiceKey)
        const charges = await NiceData.fetchItemsFromFirebase(chargeRef)

        //attach charges
        this.$set(invoice, 'charges', charges)

        // calculate totals
        if(invoice.charges && invoice.charges.length) {
            const total = invoice.charges.reduce((a, b) => a + (b.amount || 0), 0)
            this.$set(invoice, 'total', total )
        } else {
            this.$set(invoice, 'total', 0)
        }

        this.invoice = invoice
    },

    mounted () {
  
    }

}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


// WEBPACK FOOTER //
// OneInvoice.vue?73753254